import { createSlice } from "@reduxjs/toolkit";

const BlockedSlice = createSlice({
    name:"blocked",
    initialState : {
      isBlocked:false
    },
    reducers : {
        updateBlockedStatus(state,action){
            state.isBlocked = action.payload
        }
    }

});

export const BlockedActions = BlockedSlice.actions
export default BlockedSlice.reducer